import React from 'react';
import {
    Dialog, DialogContent, Box, Typography, Paper, CardHeader, Grid, Tooltip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip,
    DialogTitle
} from '@mui/material';
import {
    Refresh as RefreshIcon,
    CheckCircle as CheckCircleIcon,
    HourglassEmpty as HourglassEmptyIcon,
    AccessTime as AccessTimeIcon,
    Edit as EditIcon,
    Close as CloseIcon,
    Attachment as AttachmentIcon,
    Replay as ReplayIcon
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import configAPI from '../../api/config';

const TicketDetailModal = ({
    open,
    onClose,
    selectedTicket,
    isMobile,
    formatDate,
    getStatusColor,
    getPriorityColor,
}) => {
    const BASE_URL = configAPI.REACT_APP_API_BASE_URL;
 const currentStatus = selectedTicket?.statusHistory && selectedTicket.statusHistory.length > 0
        ? selectedTicket.statusHistory[0].status
        : selectedTicket?.status || '';
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile}>
            <DialogTitle sx={{ 
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'primary.main',
                    color: 'white'
                }}>
                    <Typography variant="h6">Ticket #{selectedTicket?.id}</Typography>
                    <IconButton size="small" sx={{ color: 'white' }} onClick={onClose}><CloseIcon /></IconButton>
                </DialogTitle>

                <DialogContent dividers sx={{ pt: 3 }}>
                    {selectedTicket && (
                        <Grid container spacing={1.5}>
                            <Grid size={{ xs: 12 }}>
                                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 1.5, backgroundColor: "#fff" }}>
                                    <CardHeader sx={{ px: 0, py: 0.5, mb: 1, minHeight: "unset", "& .MuiCardHeader-content": { overflow: "hidden" } }}
                                        title={<Typography variant="body2" fontWeight='bold'>Ticket Information</Typography>}
                                        action={
                                            <Box display="flex" gap={0.5} flexWrap="wrap">
                                                <Chip label={currentStatus.toUpperCase()} color={getStatusColor(currentStatus)} sx={{lineHeight:'inherit'}} size="small" />
                                                <Chip label={selectedTicket.priority.toUpperCase()} color={getPriorityColor(selectedTicket.priority)} sx={{lineHeight:'inherit'}} size="small" />
                                            </Box>
                                        }
                                    />
                                    <Grid container spacing={0.5}>
                                        <Grid size={{ xs: 12, sm: 4 }}><Typography variant="caption" color="text.secondary">School</Typography><Typography variant="body2" noWrap>{selectedTicket.school || "—"}</Typography></Grid>
                                        <Grid size={{ xs: 12, sm: 4 }}><Typography variant="caption" color="text.secondary">Category</Typography><Typography variant="body2" noWrap>{selectedTicket.category || "—"}</Typography></Grid>
                                        <Grid size={{ xs: 12, sm: 4 }}><Typography variant="caption" color="text.secondary">Created By</Typography><Typography variant="body2" noWrap>{selectedTicket.createdBy || "—"}</Typography></Grid>
                                        <Grid size={{ xs: 12, sm: 4 }}><Typography variant="caption" color="text.secondary">Title</Typography>
                                            <Tooltip title={<Typography variant="body2" sx={{ p: 0.5 }}>{selectedTicket.subject}</Typography>} placement="top-start"
                                                componentsProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "text.primary", boxShadow: "none", border: "1px solid", borderColor: "divider", maxWidth: 320 } } }}>
                                                <Typography variant="body2" sx={{ mt: 0.25, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", color: "text.primary" }}>{selectedTicket.subject || "—"}</Typography>
                                            </Tooltip>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 8 }}>
                                            <Typography variant="caption" color="text.secondary">Description</Typography>
                                            <Tooltip title={<Typography variant="body2" sx={{ p: 0.5 }}>{selectedTicket.description}</Typography>} placement="top-start"
                                                componentsProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "text.primary", boxShadow: "none", border: "1px solid", borderColor: "divider", maxWidth: 320 } } }}>
                                                <Typography variant="body2" sx={{ mt: 0.25, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", color: "text.primary" }}>{selectedTicket.description || "—"}</Typography>
                                            </Tooltip>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}>
                                            <Typography variant="caption" color="text.secondary">Attachments</Typography>
                                            <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                                                {selectedTicket?.attachments && selectedTicket.attachments.length > 0 ? (
                                                    selectedTicket.attachments.map((filePath, index) => {
                                                        const fileUrl = `${BASE_URL}${filePath}`;
                                                        const fileName = `Attachment ${index + 1}`;

                                                        return (
                                                            <Chip
                                                                key={index}
                                                                icon={<AttachmentIcon fontSize="small" />}
                                                                label={fileName}
                                                                size="small"
                                                                variant="outlined"
                                                                clickable
                                                                component="a"
                                                                href={fileUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    lineHeight:'inherit',
                                                                    '& .MuiChip-label': { pl: 1 },
                                                                    textDecoration: 'none',
                                                                    cursor: 'pointer',
                                                                    color: 'primary.main',
                                                                    borderColor: 'primary.main',
                                                                    '&:hover': {
                                                                        backgroundColor: 'primary.50',
                                                                        textDecoration: 'underline',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    },
                                                                    '& .MuiChip-icon': {
                                                                        color: 'primary.main'
                                                                    }
                                                                }}
                                                            />
                                                        );
                                                    })
                                                ) : (
                                                    <Typography variant="body2" color="text.secondary" mt={0.5}>No attachments</Typography>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 2, overflow: "hidden", display: 'flex', flexDirection: 'column', height: 200 }}>
                                    <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0", flexShrink: 0 }}>
                                        <Typography variant="body2" fontWeight={600}>Timeline</Typography>
                                    </Box>
                                    {selectedTicket?.statusHistory && selectedTicket.statusHistory.length > 0 ? (
                                        <Box sx={{ overflow: 'auto', flex: 1, maxHeight: '200px' }}>
                                            <Table size="small" stickyHeader sx={{ minWidth: 500, '& .MuiTableCell-root': { py: 0.5, px: 1, borderBottom: '1px solid #f0f0f0', fontSize: '0.75rem', lineHeight: 1.1 }, '& .MuiTableRow-root': { height: 36 } }}>
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: '#f8f9fa', '& .MuiTableCell-head': { py: 1, backgroundColor: '#f8f9fa', fontWeight: 600, fontSize: '0.75rem', whiteSpace: 'nowrap', position: 'sticky', top: 0, zIndex: 1 } }}>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell sx={{ minWidth: 140 }}>Date & Time</TableCell>
                                                        <TableCell align="center" sx={{ minWidth: 100 }}>Status</TableCell>
                                                        <TableCell sx={{ minWidth: 180 }}>Remarks</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {selectedTicket.statusHistory.map((event, index) => (
                                                        <TableRow key={index} sx={{ height: 42, '&:hover': { backgroundColor: '#f8fafc' }, '&:last-child td': { borderBottom: 'none' } }}>
                                                            <TableCell sx={{ color: 'text.secondary', width: 30 }}>{index + 1}</TableCell>
                                                            <TableCell sx={{ minWidth: 140 }}>
                                                                <Box sx={{ lineHeight: 1.2 }}>
                                                                    <Typography variant="caption" sx={{ fontWeight: 500, display: 'block', fontSize: '0.75rem' }}>
                                                                        {formatDate(event.timestamp)}
                                                                    </Typography>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ minWidth: 100 }}>
                                                                <Chip
                                                                    label={event.action?.toUpperCase() || event.status?.toUpperCase()}
                                                                    // size="small"
                                                                    color={getStatusColor(event.status)}
                                                                    sx={{ fontSize: '12px', 
                                                                    lineHeight:'inherit',height: 20, }}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography variant="body2" sx={{ fontSize: '0.75rem', lineHeight: 1.2, maxHeight: '2.4em', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                                                                    {event.comment || 'No remarks'}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    ) : (
                                        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', py: 3, backgroundColor: '#fafafa' }}>
                                            <Typography variant="caption" color="text.secondary">No timeline events available</Typography>
                                        </Box>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
            
        </Dialog>
    );
};

export default TicketDetailModal;